import Price from "components/Price/Price"
import { Col, Row } from "elemental-react16"
import { Button, Card, Icon, Modal, Segment, Image, Message,Table } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { observer } from "mobx-react"
import React, { Component } from "react"
import shop from "shop/shop"
import _ from "lodash"
import moment from "moment"
import "moment/locale/de"
import CostCentres  from "components/CostCentres/CostCentres";
import AccountReset from "components/Account/AccountReset"
import swal from "sweetalert"
import OrderModel from "../../../shop/OrderModel";
import { Redirect } from "react-router"


const setPasswordAsAdmin = ( account ) => {

  swal( {
      text            : "Passwort setzen",
      type            : "prompt",
      title           : "Neues Passwort",
      showCancelButton: true,
      closeOnConfirm  : false,
      closeOnCancel   : true,
    },
    newPassword => {
      if ( !newPassword ) return
      shop.fetch( `/shop/rest/security/user/${account.userid}/logins?passupdate=1`, {
        method: "POST",
        body  : JSON.stringify( {
          ...account,
          "password": newPassword,
          "newpass" : newPassword,
          "repeat"  : newPassword
        } )
      } )
        .then( res => {
          console.log( "PW CHANGE", res )
          swal( translate( "reset.success" ),
            translate( "Passwort erfolgreich gesetzt." ),
            "success" )
        } )
        .catch( err => {
          console.error( err )
          swal( "Fehler", "Leider konnte IhrPasswort nicht geändert werden", "error" )
        } )

    }
  )
}

export function fetchExtraOrderRessources( order ) {
  return shop.fetch( `/shop/rest/data/customer/current/extrainfo?start=0&count=50&subref=${order.map_id}` )
    .then( res => {
      order.extrainfo = res.map( data => new OrderPDF( data ) )
      return new OrderModel(order)
    } )
}


class Accounts extends React.Component {

  state = {
    loading : false,
    accounts: [],
    user: false,
  }

  async componentDidMount() {
    this.setState( { loading: true } )

    const users    = await shop.fetch( `/shop/rest/users/data?start=0&count=100&filter=%7B%22customer_id%22%3A%22${shop.session.value.map_id}%22%7D`)

    var temp;
    if (users.length > 0) {
      this.user = users[0];
      temp = await shop.fetch( `/shop/rest/security/user/${users[0].id}/logins` )
    } else {
      temp = [];
    }

    const accounts = temp;
    console.log( { accounts } )
    this.setState( { accounts, loading: false } )
  }

  render() {
    const { accounts } = this.state
    return <div>
      <Segment.Group>
        {accounts.map( account => {
          return <Segment clearing key={account.login}>
            <Button floated={"right"} onClick={() => setPasswordAsAdmin( account )}>{translate( "change Password" )}</Button>
            <div className="pa2 b">{account.login} {account.contact}</div>
          </Segment>
        } )}
      </Segment.Group>
    </div>
  }
}

export const orderTypes = {
  0: "Order",
  1: "Delivery",
  2: "Invoice",
}

class OrderPDF {
  constructor( order ) {
    Object.assign( this, order )
    this.typeName = orderTypes[ order.type ] || "Unknown"
    this.url = `${shop.config.BASE}/shop/rest/data/customer/current/extraresources/` + encodeURIComponent(order.map_id)
  }
}

@observer
export default class AccountPage extends Component {

  state = {
    session        : shop.session || {}, locations: [],
    orders         : [],
    current        : 0,
    showAddressBook: false,
    noMoreOrders   : false,
    frachtkosten: true
  }

  loadMore = () => {
    let { orders, current } = this.state
    let pageSize = 20
    let start = current
    current = current + pageSize
    this.setState( { loading: true } )
    shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
      .then( async res => {
        let extras = res.values.map( order => fetchExtraOrderRessources( order ) )
        await Promise.all( extras )
        console.log( "FROM API", { res } )
        orders = orders.concat( res.values )
        this.setState( { loading: false, current, orders } )
        if ( res.values.length === 0 ) {
          this.setState( { noMoreOrders: true, current, orders } )
        }
      } )
  }

  loadSession = ( session ) => {
    this.loadMore()
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        this.setState( { locations } )
      } )
  }

  componentDidMount() {
    shop.events.authentified.add( this.loadSession )
    // this.loadSession()Top
  }

  componentWillUnmount() {
    shop.events.authentified.remove( this.loadSession )
  }

  render() {
    let { locations, loading, noMoreOrders, orders,frachtkosten } = this.state
    let billingAddress = shop.session.value
    let shortlist = locations.slice( 0, 100 )
    
    if ( !shop.session ) return <Redirect to={"/"}/>
    if ( !shop.session.value ) return <Redirect to={"/"}/>
    if ( !shop.session.value.extras ) return <Redirect to={"/"}/>
    console.log("location0",location[0])
    const note = shop.config.showNote && shop.session.value.extras[ "ts-note" ]
    if(shop.session.value.extras){
      if(shop.session.value.extras.mainlink){
        if(!locations){
          locations = [];
        }
        if(locations.length == 0 && shop.session.value.extras.mainlink != 'yes'){
          locations[0] = [];
          locations[0].mapid = shop.session.value.extras.mainlink; 
          if(shop.session.value.extras.linkcountry){ locations[0].country = shop.session.value.country; }
          if(shop.session.value.extras.linkstreet){ locations[0].street = shop.session.value.street; }
          if(shop.session.value.extras.linktitle){ locations[0].name1 = shop.session.value.title; }
          if(shop.session.value.extras.linkpcode){ locations[0].pcode = shop.session.value.pcode; }
          if(shop.session.value.extras.linkcity){ locations[0].city = shop.session.value.city; }
        }
      }
    }
    console.log("location0POST",frachtkosten)
    
    let locationsOnDisplay = _.map( shortlist, ( location, key ) => {
      return (<Card key={key}
                    sm="1/5">
        <Card.Header>
          <div className="pa3 b black-60">{translate( "Lieferadresse" )}</div>
        </Card.Header>
        <Card.Content>
          <Address location={location}/>
        </Card.Content>
      </Card>)
    } )

    return (
      <div className="container pt4">
        <h1 className="page-title"><i className="icon-vcard icon-lg"/><strong>{translate( "My Account" )}</strong></h1>
        <p>{translate( "View your customer data and recent orders" )}</p>
      

        {/*<section>*/}
        {/*<div className="row-title tl">*/}
        {/*<h2>Mein Benutzer</h2>*/}
        {/*</div>*/}
        {/*</section>*/}

        {/*<section>*/}
        {/*<div className="row-title tl">*/}
        {/*<h2>Adressbuch</h2>*/}
        {/*</div>*/}
        {/*<Button onClick={() => { this.setState( { showAddressBook: true } )}}> Adressbuch öffnen </Button>*/}
        {/*{showAddressBook && <AddressBook onClose={() => {this.setState( { showAddressBook: false } )}}/>}*/}
        {/*</section>*/}


        {/*<section className="pt4">
        <div className="row-title title--left">
          <h2 className="title">{translate( "Budget" )}</h2>
        </div>
        <CostCentres/>
      </section>*/}

        <section className="pt2">
          <div className="">
            <p className="fw6 f4 cssOptima">{translate("Meine Lindt Kundennr.")} {shop.session.value.map_id}</p>
            </div>
          </section>

        <section className="pt4">
        
        <div className="row-title title--left">
          <h2 className="title">{translate( "Ihren persönlichen Ansprechpartner erreichen Sie unter" )}</h2>
        </div>
        
        {shop.session.value.extras && shop.session.value.extras.verName && <div className={"pb2"}>
          <div className={"pa3 box-shadow ba bg-white mh-auto center ml0-ns "} style={{ maxWidth: "100%", width: "390px" }}>
            <div>
              <div className="flex flex-row-ns flex-column items-center">
                <div className="pr3-ns pb0-ns pb3 tc">
                  <Image
                    title={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    alt={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    className={"shadow-inset"}
                    width={210}
                    circular
                    src={`/image/${shop.session.value.extras.verName}.jpg`}/>
                </div>
                <div>
                  <div className={"b black"}>{shop.session.value.extras.verName}</div>
                  <div className={"pb2 nowrap f6 black-80"}> {shop.session.value.extras.verFunktion}</div>
                  {shop.session.value.extras.verPhone &&
                    <div className={""}><a href={`tel:${shop.session.value.extras.verPhone}`}>{shop.session.value.extras.verPhone}</a></div>}
                  {shop.session.value.extras.verMail && <div className={""}><a
                    href={`mailto:${shop.session.value.extras.verMail}?subject=Kundenanfrage Ortho Walker, Kunde #${shop.session.value.map_id}`}>{shop.session.value.extras.verMail}</a>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>}
        {shop.session.value.extras.verMail && <Button className={"db w-100 w-auto-ns"} basic as={"a"}
                                                      href={`mailto:${shop.session.value.extras.verMail}?subject=Kundenanfrage Ortho Walker, Kunde #${shop.session.value.map_id}`}><Icon
          name={"mail"}/> <span>{shop.session.value.extras.verMail}</span></Button>}
        {shop.session.value.extras.verPhone && <Button className={"db w-100 w-auto-ns"} basic as={"a"} href={`tel:${shop.session.value.extras.verPhone}`}><span><Icon
          name={"phone"}/> {shop.session.value.extras.verPhone}</span></Button>}
        {/*!process.env.REACT_APP_SERVICE_EMAIL &&
          <Button className={"db w-100 w-auto-ns"} basic as={Link} to={"/form/customer_contact"}>{translate( "Kontaktformular" )}</Button>*/}
        {process.env.REACT_APP_SERVICE_EMAIL &&
          <Button className={"db w-100 w-auto-ns"} basic as={"a"} href={`mailto:${process.env.REACT_APP_SERVICE_EMAIL}`}>{translate( "Kontakt" )}</Button>}
          			<div style={{maxWidth: "400px", zIndex: 101}} className="tl  ba b--black-10 pa2 ma2">
									{/*<p className="f6 fw6"> {translate("Bitte wenden Sie sich bei Rückfragen oder Display-Bestellungen direkt an unsere Customer-Sales-Abteilung.")} </p> */}
									<p className="f4 fw5"> {translate("Telefon")}: 0241-8881-7703 <br/>
									{translate("E-Mail")}: customer-sales-de@lindt.com </p>
								</div>
      </section>


        <section className="mt4">
          <div className="row-title title--left">
            <h2 className="title">{translate( "change Password" )}</h2>
          </div>

          <AccountReset email={shop.session.value.email}/>
        </section>

        <section className="mt4 pb5">
          <Row>
            <Col sm="1">
              <div className="row-title title--left">
                <h2 className="title">{translate( "Order History" )}</h2>
              </div>
              {orders.length >= 0 && <OrderTable orders={orders}/>}
              {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
              {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}
              {!noMoreOrders && <div className="pa2 tc">
                <Button onClick={this.loadMore} loading={loading}>{translate("mehr laden")}</Button>
              </div>}
            </Col>
          </Row>
        </section>
        {/*<pre>Session: {JSON.stringify(session, null, 2)}</pre>*/}
        {/*<pre>Adressen:{JSON.stringify(this.state.locations, null, 2)}</pre>*/}
      </div>
    )
  }
}

const OrderTable = ( { orders } ) => {
  if ( orders.length === 0 ) {
    return null
    // return (<p>Keine Bestellungen gefunden.</p>)
  }

  return (
    <div className="table-scroller">
      <Table>
        <colgroup>
          <col width="30%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="5%"/>
        </colgroup>

        <tbody>
        <tr>
          <th className="ttu">{translate( "order number" )}</th>
          <th className="ttu tl">{translate( "positions" )}</th>
          <th className="ttu tl">{translate( "Bestellmenge in VE" )}</th>
          <th className="ttu tl">{translate( "date" )}</th>
          <th className="ttu tc">{translate( "status" )}</th>
        </tr>

        {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow key={order.id} order={order}/> )}
        </tbody>
      </Table>
    </div>
  )
}

const OrderPreviewRow = ( { order } ) => {
  const orderDate = moment( order.register )
    .format( "DD.MM.YYYY" )
  const orderLink = `/account/orders/${order.map_id}`
  const isSuccess = (order.status === "2" || order.status === 2)
  let orderstateCounter = 0
  let orderstate = 0
  let orderstateArray = ["Bestellung übermittelt","Rückstand","Teilweise geliefert"];
  
  for(let i = 0; order.positions.length > i; i++){
    
    /*if(order.positions[i].open != 0 && orderstate != 2){
      orderstate = 1
    }
    if(orderstate == 1 && order.positions[i].open == 0){
      orderstate = 2
    }*/
    if(order.positions[i].open != 0){
      orderstateCounter++
    }
    
    //console.log("order: ",order.map_id,"open: " ,order.positions[i].open," orderstate ",orderstate)
  }
  console.log("orderstatecounter: ", orderstateCounter, " order.length: ", order.positions.length)
  if(orderstateCounter == order.positions.length){
    orderstate = 1
  }
  if(orderstateCounter < order.positions.length){
    orderstate = 2
  }
  if(orderstateCounter == 0){
    orderstate = 0
  }

  var counterLieferschein = 0
  var counterRechnung = 0
  var counterAuftrag = 0
  order.extrainfo.map((answer, i) => {     
    if(answer.content && answer.content.includes("VKSF")){
     
     counterRechnung++
    } })
    
    order.extrainfo.map((answer, i) => {     
           
      if(answer.content && answer.content.includes("VKLS")){
        counterLieferschein++
      }
   })
  var counterBestellmenge = 0
    order.positions.map((item) => {
      counterBestellmenge += item.count
   })
   console.log("Bestellmenge:", counterBestellmenge, order)

  return (
    <tr>
      <td>
        <Link to={orderLink}>
          #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
        </Link>
      </td>


      {/*<td className="tr"><Price>{order.netto}</Price></td> */}
      <td className="pl2 tr">{order.positions.length}</td>
      <td className="pl2 tr">{counterBestellmenge}</td>
      <td className="tc">
        <div className="nowrap">{orderDate}</div>
      </td>
      <td className="tc">
        <div className="flex flex-row items-center">
        <td className="tc">{isSuccess ? <i className="icon-ok"></i> : <i className="icon-cancel"></i>}{translate(orderstateArray[orderstate])}</td>
        </div>
      </td>
    </tr>
  )
}

const Address = ( { title, location } ) => {
  const isDeliveryAddress = location.mapid === (shop.cart.deliveraddress && shop.cart.deliveraddress.mapid)
  return (
    <React.Fragment>
      <div className="address-block pb3">
        <div className=""><strong>{location.name1} {location.name2} {location.name3}</strong></div>
        <div className="block"><strong>{location.company || <span className="black-40">&hellip;</span>}</strong>
          <br/>
          {location.street || <span className="black-40">&hellip;</span>}<br/>
          {location.pcode} {location.city || <span className="black-40">&hellip;</span>}<br/>
          {location.country || <span className="black-40">&hellip;</span>}<br/>
        </div>
        <div className="pt3">
          {/*<a onClick={() => {shop.cart.setAddress( { location } )}} className="black-40" href="#">als Lieferadresse</a> <br/>*/}
          {/*<a className="black-40" href="#">Änderung beantragen</a> <br/>*/}
          {/*<a className="black-40" href="#">löschen</a> <br/>*/}
        </div>
      </div>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/theme/lindtbShop/pages/AccountPage.js